// RFC-0008 T4: 顶层路由
import { Route, Routes } from 'react-router-dom';
import { UserGate, UserProvider } from './components/user-provider';
import { HomeRoute } from './routes/home';
import { DeckRoute } from './routes/deck';
import { DemoRoute } from './routes/demo';

export function App() {
  return (
    <UserProvider>
      <UserGate>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/deck/:deck_id" element={<DeckRoute />} />
          <Route path="/demo/:template_id" element={<DemoRoute />} />
          <Route path="*" element={<HomeRoute />} />
        </Routes>
      </UserGate>
    </UserProvider>
  );
}
